import * as React from "react";
import { createRoot, Root } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

import App from "./App";

// eslint-disable-next-line no-redeclare
/* global document, Office, module, require */

const rootElement: HTMLElement = document.getElementById("container");
const root: Root = createRoot(rootElement);

/* Render application after Office initialized */
Office.onReady(() => {
  root.render(
    <FluentProvider theme={webLightTheme}>
      <App />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    const NextApp = require("./App").default;
    root.render(NextApp);
  });
}
